import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {ReportsApi} from '@/sdk/api-services';
import {renderAsync} from 'docx-preview';
import {Component, Prop} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class AreaReportComponent extends VueWrapper {
    public $refs!: {
        reportContainer: HTMLDivElement;
    };

    @Prop({
        type: String,
        required: true,
    })
    public areaId!: string;

    @Prop({
        type: String,
        required: true,
    })
    public siteId!: string;

    public hasReport: boolean = false;
    public isLoading: boolean = false;
    public errorMessage: string = '';

    public reportsApi: ReportsApi = new ReportsApi();
    private reportData: ArrayBuffer | null = null;

    public async mounted() {}

    public async loadAndRenderReport() {
        this.isLoading = true;
        this.errorMessage = '';
        this.hasReport = false;
        this.reportData = null;

        if (this.$refs.reportContainer) {
            this.$refs.reportContainer.innerHTML = '';
        }

        this.reportsApi
            .generateAreaReport(this.siteId, this.areaId, false)
            .then(async res => {
                const arrayBuffer = res.data;
                this.reportData = arrayBuffer; // Store the report data for download

                await renderAsync(arrayBuffer, this.$refs.reportContainer, this.$refs.reportContainer, {
                    className: 'docx',
                    inWrapper: false,
                    hideWrapperOnPrint: true,
                    ignoreWidth: true,
                    ignoreHeight: true,
                    ignoreFonts: true,
                    breakPages: true,
                    ignoreLastRenderedPageBreak: true,
                    experimental: false,
                    trimXmlDeclaration: true,
                    useBase64URL: false,
                    renderChanges: false,
                    renderHeaders: true,
                    renderFooters: true,
                    renderFootnotes: true,
                    renderEndnotes: true,
                    renderComments: false,
                    renderAltChunks: true,
                    debug: false,
                });

                this.hasReport = true;
            })
            .catch(err => {
                this.AlertSrv.show('error', err.message ?? 'Unable to load report file.');
                this.errorMessage = 'Could not load the report preview. Please try again later.';
                this.hasReport = false; // Ensure hasReport is false on error
            })
            .finally(() => {
                this.isLoading = false;
                // BUG FIX: Removed 'this.hasReport = false' from here as it would always override the status.
            });
    }

    public downloadReport() {
        if (!this.reportData) {
            this.AlertSrv.show('warning', 'No report data available to download. Please generate a report first.');
            return;
        }

        // Create a Blob from the ArrayBuffer
        const blob = new Blob([this.reportData], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report-site-${this.siteId}-area-${this.areaId}.docx`); // Set a dynamic filename
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the element and revoking the URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}
